import classNames from 'classnames';
import useTranslation from 'next-translate/useTranslation';
import React, { useEffect, useMemo, useState } from 'react';

import AddCart from '@/components/common/AddCartNew';
import Constants from '@/constants/const';
import { AddToCartReferType, BusEventKeys } from '@/constants/track';
import { StatusEnum } from '@/types/cart';

import { ProductCardProps } from './';
import CardBody from './cardBody';
import CardHead from './cardHead';
import CountDownLabel from './countDownLabel';
import LightningLine from './lightning';
import LightningReminder from './lightningReminder';
import styles from './verticalCardInner.module.scss';

export const soldOutStatus = [StatusEnum?.sold_out as string];

const VerticalCardInner: React.FC<Partial<ProductCardProps>> = props => {
  const {
    data,
    addCartParams,
    children,
    showAddBtn = true,
    preSell,
    onATC,
    produtLink,
    trackDataInDialog,
    fetchYouMayLike,
    useNewUpdateCartApi
  } = props;

  //如果是直邮商品, referType全部改为pantry
  if (data.is_pantry) {
    addCartParams.referType = AddToCartReferType.pantry;
  }

  const { t, lang } = useTranslation('common');

  const addCartCode = () => {
    return (
      <div onClick={e => e.stopPropagation()}>
        {data?.category === 'bundle' || data?.is_hotdish === 'Y' ? (
          <div className={classNames(styles.btnView, styles.btns)}>
            <span>{t('btn_view')}</span>
          </div>
        ) : showAddBtn ? (
          <div className={classNames(styles.btnsContainer, styles.btns)}>
            <div
              className={styles.addWrap}
              onClick={e => {
                e.stopPropagation();
                e.preventDefault();
              }}>
              <AddCart
                {...addCartParams}
                preSell={preSell}
                data={data}
                link={produtLink?.to}
                onNumChange={onATC}
                isInProductCard
                useNewUpdateCartApi={useNewUpdateCartApi}
                trackDataInDialog={trackDataInDialog}
                fetchYouMayLike={fetchYouMayLike}
              />
            </div>
          </div>
        ) : data?.status === 'begoing' ? (
          <LightningReminder {...props} />
        ) : (
          ''
        )}
      </div>
    );
  };

  return (
    <div className={classNames(styles.itemBox, styles.vertical)}>
      <div className={styles.itemInfo}>
        <CardHead {...props}>{addCartCode()}</CardHead>
        <CardBody {...props} />
        {data?.status === 'ongoing' && <LightningLine {...props} />}
        {data?.status === 'begoing' && !!props?.countDownTimeStamp && (
          <CountDownLabel start={props?.countDownTimeStamp} end={props?.data?.start_time} status="begoing" />
        )}
      </div>
      <div
        className={styles.childBox}
        onClick={e => {
          e.stopPropagation();
          e.preventDefault();
        }}>
        {children}
      </div>
    </div>
  );
};

export default VerticalCardInner;
